module.exports = __webpack_public_path__ + "img/infographic_shopping_sessions.7b169531.png";